import { hasValue, hasStringValue } from './validation';

const AUTH_STORAGE_KEY = 'ClientPortalAuthToken';
const COMPANY_STORAGE_KEY = 'ClientPortalCompanyInfo';

let _authObj: any = null;

export function getAuthObject(): any {
  if (hasValue(_authObj)) {
    return _authObj;
  }
  const auth = localStorage.getItem(AUTH_STORAGE_KEY);
  if (hasStringValue(auth)) {
    _authObj = JSON.parse(auth!);
    return _authObj;
  }
  return null;
}

export function setAuthObject(authObject: any): void {
  if (hasValue(authObject)) {
    _authObj = authObject;
    const json = JSON.stringify(authObject);
    localStorage.setItem(AUTH_STORAGE_KEY, json);
  } else {
    _authObj = null;
    localStorage.removeItem(AUTH_STORAGE_KEY);
  }
}

export function removeAuthObject(): void {
  setAuthObject(null);
}

export function getSelectedCompanyInfo(): any {
  const obj = localStorage.getItem(COMPANY_STORAGE_KEY);
  if (hasStringValue(obj)) {
    return JSON.parse(obj!);
  }
  return null;
}

export function setSelectedCompanyInfo(info: any): void {
  if (hasValue(info)) {
    localStorage.setItem(COMPANY_STORAGE_KEY, JSON.stringify(info));
  } else {
    localStorage.removeItem(COMPANY_STORAGE_KEY);
  }
}

export function removeSelectedCompanyInfo(): void {
  setSelectedCompanyInfo(null);
}

export function getCurrentUserId(): number | null {
  const authObj = getAuthObject();
  if (hasValue(authObj)) {
    return +(authObj['user_id']);
  }
  return null;
}

export function getCurrentUsername(): string | null {
  const authObj = getAuthObject();
  if (hasValue(authObj)) {
    return authObj['username'];
  }
  return null;
}

export function getCurrentAccessToken(): string | null {
  const authObj = getAuthObject();
  if (hasValue(authObj)) {
    return authObj['access_token'];
  }
  return null;
}
